"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Plan_890 = void 0;
var Plan_890 = exports.Plan_890 = {
  planNumber: 890,
  kindOfCover: "Accident & GVE",
  externalName: "Basic Care",
  coolingOffPeriod: true,
  gapOnly: true,
  dental: false,
  routineCare: false,
  emergencyBoarding: true,
  emergencyBoardingFees: "$500",
  petSpecies: ["CANINE", "FELINE"],
  upmExcessOptions: [{
    "excess": 0,
    "levelOfCover": 75,
    "excessCode": "3825",
    "excessNo": 3825
  }, {
    "excess": 100,
    "levelOfCover": 75,
    "excessCode": "3826",
    "excessNo": 3826
  }],
  levelsOfCover: [75],
  staffOnly: false,
  staffLevelsOfCover: [],
  stepDownLevelsOfCover: [],
  stepDown: false,
  limits: {
    "ageLimits": {
      "minAgeDays": 56,
      "maxAgeDays": null,
      "displayValue": "Older than 8 weeks"
    },
    "annualLimit": {
      "amount": 15000,
      "formattedAmount": "$15,000",
      "displayValue": "$15,000"
    },
    "cruciateLigament": "$3,200 sub-limit",
    "paralysisTick": "$1,500 sub-limit",
    "tickParalysis": "$1,500 sub-limit",
    "consultationLimit": "$300 sub-limit",
    "consultationsAndVet": "$300 sub-limit",
    "consultationsAndVisits": "$300 sub-limit",
    "consultation": true,
    "emergencyBoardingFees": "$500",
    "emergencyBoardingLimit": "$500 sub-limit"
  },
  waitingPeriods: {
    "detailed": {
      "waitingPeriodMessages": ["30 days for general veterinary expenses.", "No waiting period for specified accidental injuries.", "No waiting period for emergency boarding."],
      "waitingPeriod": "30 days for general veterinary expenses.<br/>No waiting period for specified accidental injuries.<br/>No waiting period for emergency boarding.",
      "itemisedWaitingPeriods": {
        "generalVeterinaryExpenses": {
          "waitTime": "30 days",
          "label": "general veterinary expenses"
        },
        "specifiedAccidentalInjuries": {
          "waitTime": "No waiting period",
          "label": "specified accidental injuries"
        },
        "emergencyBoarding": {
          "waitTime": "No waiting period",
          "label": "emergency boarding"
        }
      }
    }
  },
  customCoverDetails: {
    "groomingComplication": true,
    "coversIllness": true,
    "infectiousDisease": true
  },
  isBasePlan: true,
  addOns: []
};
var _default = exports["default"] = {
  Plan_890: Plan_890
};